import { css } from '@emotion/react'

export const block = css`
  display: block;
`

export const inline = css`
  display: inline;
`

export const inlineBlock = css`
  display: inline-block;
`

export const flex = css`
  display: flex;
`

export const none = css`
  display: none;
`
